// src/utils/papConfig.js
//
// Adressen van het assistentplatform (PAP). Gedeeld door de chatwidget en de
// gesprekkenlijst, die transcripten rechtstreeks bij de runtime-engine ophaalt.
//
// Lokaal tegen PAP in Docker ontwikkelen: zet in frontend/.env
//   REACT_APP_PAP_SDK_URL=http://localhost:5173/sdk/chat-interface-sdk.js
//   REACT_APP_PAP_CONTROL_PLANE_URL=http://localhost:18001
//   REACT_APP_PAP_RUNTIME_ENGINE_URL=http://localhost:18000
//   REACT_APP_PAP_ASSET_BASE_URL=http://localhost:5173/sdk

export const PAP_ASSISTANT_ID = 'doorloopjes';

export const PAP_CONFIG = {
  sdkUrl:
    process.env.REACT_APP_PAP_SDK_URL ||
    'https://storage.googleapis.com/pap-chat-interface/sdk/chat-interface-sdk.js',
  controlPlaneUrl:
    process.env.REACT_APP_PAP_CONTROL_PLANE_URL || 'https://control-plane-dxm23hanhq-ez.a.run.app',
  runtimeEngineUrl:
    process.env.REACT_APP_PAP_RUNTIME_ENGINE_URL || 'https://runtime-engine-dxm23hanhq-ez.a.run.app',
  assetBaseUrl:
    process.env.REACT_APP_PAP_ASSET_BASE_URL || 'https://storage.googleapis.com/pap-chat-interface/sdk',
};
